module.exports = __webpack_public_path__ + "static/media/15586.ed9f680f.jpg";